import { render, staticRenderFns } from "./GridCajas.vue?vue&type=template&id=061757e3&"
import script from "./GridCajas.vue?vue&type=script&lang=js&"
export * from "./GridCajas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports